export const customStringFilter = (row, columnId, filterValue) => {
  const operator = (filterValue?.operator || "").toLowerCase();
  const cell = (row.getValue(columnId) ?? "").toString().toLowerCase();
  const val = (filterValue?.value ?? "").toString().toLowerCase();

  const isEmpty = cell.trim() === "";

  switch (operator) {
    case "vacío":
      return isEmpty;
    case "no vacío":
      return !isEmpty;
    case "contiene":
      return cell.includes(val);
    case "igual":
      return cell === val;
    case "empieza con":
      return cell.startsWith(val);
    case "termina con":
      return cell.endsWith(val);
    default:
      return true;
  }
};

export const customNumberFilter = (row, columnId, filterValue) => {
  const operator = (filterValue?.operator || "").toLowerCase();
  const raw = row.getValue(columnId);

  if (operator === "vacío")
    return raw === null || raw === undefined || raw === "";
  if (operator === "no vacío")
    return !(raw === null || raw === undefined || raw === "");

  const cell = Number(raw);
  if (Number.isNaN(cell)) return false;

  const v = Number(filterValue?.value);
  const min = Number(filterValue?.value?.min);
  const max = Number(filterValue?.value?.max);

  switch (operator) {
    case "igual":
      return cell === v;
    case "no igual":
      return cell !== v;
    case "mayor que":
      return cell > v;
    case "mayor o igual":
      return cell >= v;
    case "menor que":
      return cell < v;
    case "menor o igual":
      return cell <= v;
    case "entre":
      return (
        !Number.isNaN(min) && !Number.isNaN(max) && cell > min && cell < max
      );
    case "entre (inclusivo)":
      return (
        !Number.isNaN(min) && !Number.isNaN(max) && cell >= min && cell <= max
      );
    default:
      return true;
  }
};

export const customStatusFilter = (row, columnId, filterValue) => {
  const val = (filterValue?.value || "").toString().toLowerCase(); // vigente|vencido|proximo|no_existente
  const cell = (row.getValue(columnId) ?? "").toString().toLowerCase();
  if (!val) return true; // si no hay valor, no filtra
  return cell === val; // match exacto del estado
};

export const customProyectsFilter = (row, columnId, filterValue) => {
  const val = (filterValue?.value || "").toString().toLowerCase();
  const cell = (row.getValue(columnId) ?? "").toString().toLowerCase();
  if (!val) return true;
  return cell === val;
};

// src/filters/customSpecialtyFilter.js
export const customSpecialtyFilter = (row, _columnId, filterValue) => {
  const especialidades = row.original?.especialidadesSelec || [];

  const selected = filterValue?.value ?? filterValue;
  if (!selected) return true;

  if (selected === "Sin especialidades") {
    return especialidades.length === 0;
  }

  return especialidades.some((e) => {
    const nombre = e?.nombre?.toLowerCase().trim();
    return nombre === selected.toLowerCase().trim();
  });
};

export const customStrainFilter = (row, columnId, filterValue) => {
  const target = (filterValue?.value ?? "").toString().toLowerCase().trim();
  if (!target) return true; // sin valor => no filtra

  // El valor en la celda puede ser string ("alta") u objeto ({ value: 'alta', label: 'Alta' })
  const raw = row.getValue(columnId);
  const cell =
    raw && typeof raw === "object"
      ? (raw.value ?? raw.name ?? raw.label ?? "").toString()
      : (raw ?? "").toString();

  return cell.toLowerCase().trim() === target;
};
